import { createTheme } from "@mui/material/styles";

export const orderReleaseTable = "Order Ready to Release";

export const theme = createTheme({
  palette: {
    primary: { main: "#fff494" },
    secondary: { main: "#E4D00A" },
  },
  typography: { useNextVariants: true },
});

export const orderDetailsWithPaginationUrl = `${process.env.REACT_APP_API_ENDPOINT}/order/getOrderDetailsWithPagination/`;

export const releaseOrderUrl = `${process.env.REACT_APP_API_ENDPOINT}/order/releaseOrder`;

export const updatePoReadyUrl = `${process.env.REACT_APP_API_ENDPOINT}/order/updatePoReady`;

export const notForwarderReady = "Not forwarder Ready";
